import * as React from 'react';

const TailwindLayout = ({ children }: { children: React.ReactNode }) => {
	React.useEffect(() => {
		document.getElementsByTagName('html')[0]?.classList.add('tailwind-font-reset');
		return () => document.getElementsByTagName('html')[0]?.classList.remove('tailwind-font-reset');
	}, []);

	return (
		/*  style={{ fontSize: 'initial' }} */
		<section className='w-full h-full text-[16px] overflow-x-hidden overflow-y-auto'>{children || null}</section>
	);
};

export default React.memo(TailwindLayout);
